import { render, staticRenderFns } from "./AdjustWaitingTimeBox.vue?vue&type=template&id=0f3b75d2&scoped=true&"
import script from "./AdjustWaitingTimeBox.vue?vue&type=script&lang=js&"
export * from "./AdjustWaitingTimeBox.vue?vue&type=script&lang=js&"
import style0 from "./AdjustWaitingTimeBox.vue?vue&type=style&index=0&id=0f3b75d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3b75d2",
  null
  
)

export default component.exports